import a from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import x from "./iconfont.es5471.js";
const d = {
  display: "block"
}, h = ({ size: l = 16, useVw: t, useRem: n, color: c, withColor: o, removeClassName: e, disableSSR: m, style: i, ...g }) => {
  const p = i ? { ...d, ...i } : d;
  return /* @__PURE__ */ a.createElement(x, { disableSSR: m }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "32px-gangganjiedai", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: t ? ((l || 0) / 375 * 100).toFixed(5) + "vw" : l + (n ? "rem" : "px"), height: t ? ((l || 0) / 375 * 100).toFixed(5) + "vw" : l + (n ? "rem" : "px"), className: e ? "" : "iconpark-icon", style: p, fill: "none", ...g }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: e ? "" : "32px-æ æåè´·"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: e ? "" : "normal",
        fill: o ? r(c, 0, "#262933") : "#262933",
        datafollowfill: o ? r(c, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M17.223 6.4a.9.9 0 0 1 1.027-.751l9.207 1.434a.9.9 0 1 1-.277 1.779l-3.52-.549V15.5a.9.9 0 0 1-1.8 0V8.033l-3.887-.606a.9.9 0 0 1-.75-1.028ZM5.9 12a.9.9 0 1 0-1.8 0v15a.9.9 0 0 0 1.8 0l.006-11.615h4.95c.57 0 1.09.322 1.345.831l.593 1.186a.9.9 0 0 0 .805.498h2.958c.577 0 1.112.304 1.406.8l1.247 2.1-3.66-.199a.9.9 0 0 0-.099 1.798l5.345.291c.05.003.1.001.15-.004l4.456-.5a1.033 1.033 0 0 1 .406 2.019l-4.336 1.27a14.1 14.1 0 0 1-8.174-.074l-4.03-1.26a.9.9 0 1 0-.537 1.718l4.03 1.26a15.9 15.9 0 0 0 9.217.084l4.336-1.271a2.833 2.833 0 0 0-1.112-5.535l-3.88.435-1.811-3.05a3.436 3.436 0 0 0-2.954-1.682h-2.401l-.345-.689a3.303 3.303 0 0 0-2.954-1.826H5.9V12Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "m17.31 10.86.9-1.35a.588.588 0 0 1 .98 0l.9 1.35a.589.589 0 0 1-.49.915h-1.8a.588.588 0 0 1-.49-.915Zm8.4.149-.9 1.351c-.26.391.02.915.49.915h1.8c.47 0 .751-.524.49-.915l-.9-1.351a.588.588 0 0 0-.98 0Z"
        }
      )
    )
  )));
}, k = h;
export {
  k as default
};
